<h1 class="widget-title">{{ title() }}</h1>

<div class="widget-actions">
  <ng-content select="[widget-actions]"></ng-content>
</div>

@if (isLoading()) {
  <xui-loading-spinner></xui-loading-spinner>
}

<div class="mat-card-list comments-list">
  @for (comment of sortedComments(); track comment.id) {
    <mat-card class="compact comment-card" [class.referred]="isReferred(comment)" [style.backgroundColor]="comment.commentType?.color">
      <mat-card-content>
        <mat-card-title-group>
          <mat-card-title class="mat-bold" [class.primary]="usePrimaryText()">
            {{ comment.lastModifiedUser?.firstName }} {{ comment.lastModifiedUser?.surname }}
          </mat-card-title>
          <mat-card-subtitle class="mb-2">
            {{ comment.createdDate | date:'yyyy-MM-dd HH:mm' }}
            @if (comment.commentType?.type) {
              <span class="comment-type-badge">{{ comment.commentType.type }}</span>
            }
          </mat-card-subtitle>
        </mat-card-title-group>

        <!-- Referral Indicator -->
        @if (isReferred(comment)) {
          <div class="referral-indicator">
            <mat-icon>send</mat-icon>
            <span>{{ getReferralText(comment) }}</span>
          </div>
        }

        <!-- Transcription Playback -->
        @if (hasTranscriptions(comment)) {
          <div class="transcriptions-section">
            @for (transcription of comment.transcriptions; track transcription.id) {
              <xmed-playback [transcription]="transcription"></xmed-playback>
            }
          </div>
        }

        <!-- Comment Text -->
        @if (hasContent(comment)) {
          <div class="comment-text multiline">{{ comment.comment.text.trim() | textSanitize }}</div>
        }
      </mat-card-content>

      <!-- Attachments -->
      @if (hasUploads(comment)) {
        <mat-divider inset></mat-divider>
        <mat-card-footer>
          <mat-list class="py-0 attachments-list">
            @for (upload of comment.uploads; track upload.id) {
              <mat-list-item class="text-start mat-list-item-compact clickable">
                <mat-icon matListItemIcon>attach_file</mat-icon>
                <span matListItemTitle>{{ upload.fileName }}</span>
                <div matListItemMeta class="mx-0">
                  <button
                    mat-icon-button
                    (click)="onDownloadAttachment(upload)"
                    [disabled]="upload.processing">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                </div>
              </mat-list-item>
            }
          </mat-list>
        </mat-card-footer>
      }

      <mat-divider></mat-divider>
    </mat-card>
  }

  @if (!hasComments() && !isLoading()) {
    <mat-card>
      <mat-card-content>
        <span>No comments have been added to this patient.</span>
      </mat-card-content>
    </mat-card>
  }
</div>
